import { PaginatedData } from '../../../../../models/List';
import { RawCandidateItemResponse } from '../../../../../models/RawCandidate';
import { ApiPathParam } from '../../../../../models/SearchParamSchema';
import { axiosFactory } from '../../../../client';
import { IExamMasterCodeItem } from '../../../../user/model';
import {
  CandidateInfoToBeUpdatedResponse,
  CandidateInfoUpdateRequest,
  CreateCandidateExportResponse,
  CreateCandidateFunctionRequest,
  CreateCheckEmailEligibilityResponse,
  FilterTypeCode,
  GenerateCandidateRequest,
  RawCandidateFunctionRequest,
  RawCandidateRequest,
} from '../models';
import * as ROUTES from './routes';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 5000;

export const candidateClient = axiosFactory(baseURL, timeout);

export const getFilterListing = (typeCode: FilterTypeCode, functionName: String) => {
  const route = ROUTES.GET_FILTER_LISTING(typeCode, functionName);
  return candidateClient.get<IExamMasterCodeItem[]>(route);
};

export const postRawCandidateSearch = (
  csrfToken: string,
  data: RawCandidateRequest,
  paging: ApiPathParam
) =>
  candidateClient.post<PaginatedData<RawCandidateItemResponse>>(
    csrfToken,
    ROUTES.POST_RAW_CANDIDATE_SEARCH(paging),
    data
  );

export const postCandidateCreateGenerate = (csrfToken: string, data: GenerateCandidateRequest[]) =>
  candidateClient.post<undefined>(csrfToken, ROUTES.POST_CANDIDATE_CREATE_GENERATE, data);

export const postCandidateCreateSendEmail = (
  csrfToken: string,
  data: RawCandidateFunctionRequest
) => candidateClient.post<undefined>(csrfToken, ROUTES.POST_CANDIDATE_CREATE_SEND_EMAIL, data);

export const postCandidateCheckEmailEligibility = (
  csrfToken: string,
  data: RawCandidateFunctionRequest
) =>
  candidateClient.post<CreateCheckEmailEligibilityResponse>(
    csrfToken,
    ROUTES.POST_CANDIDATE_CREATE_CHECK_EMAIL_ELIGIBILITY,
    data
  );

export const postCandidateCreateExportExcel = (
  csrfToken: string,
  data: RawCandidateFunctionRequest
) =>
  candidateClient.post<CreateCandidateExportResponse>(
    csrfToken,
    ROUTES.POST_CANDIDATE_CREATE_EXPORT_EXCEL,
    data
  );

export const getCandidateInfoToBeUpdated = (uuid: CreateCandidateFunctionRequest) => {
  const route = ROUTES.GET_CANDIDATE_INFO_TO_BE_UPDATED(uuid);
  return candidateClient.get<CandidateInfoToBeUpdatedResponse>(route);
};

export const putUpdateAuthenticationType = (
  csrfToken: string,
  data: CreateCandidateFunctionRequest & CandidateInfoUpdateRequest
) => {
  const route = ROUTES.PUT_UPDATE_AUTHENTICATION_TYPE(data);
  return candidateClient.put<undefined>(csrfToken, route, data);
};
